<template>
  <div class="col-12" v-if="ready">
    <div class="card" v-for="(sub, key) in formatted_subject" :key="key">
      <div class="card-header">
        <h4 class="card-header-title">
          {{ sub._[0].unite_adi + ' · ' + sub._[0].konu_adi + ' · ' + sub._[0].alt_konu_adi }}
        </h4>
        <div class="btn-group">
          <a 
          @click="sub._[0].ders_anlatim_vimeo_id ? loadVideo(sub._[0], 'subject_expression') : videoAlert()"
          href="javascript:;"
          class="btn btn-sm btn-primary">
            <i :class="sub._[0].ders_anlatim_video == 'success' || viewed_videos[sub._[0].ders_anlatim_vimeo_id] !== undefined ? 'fe fe-check-circle' : 'fe fe-x-circle'">
            </i> Konu Anlatımı
          </a>
          <a href="javascript:;" @click="getQuiz(sub._[0])" :class="sub._[0].quiz == 'success' ? 'disabled' : ''"  class="btn btn-sm btn-white">
            <i :class="sub._[0].quiz == 'success' ? 'fe fe-check-circle' : 'fe fe-x-circle'"></i> Küçük Sınav
          </a>
        </div>
      </div>
      <div class="card-body">
        <div class="list-group list-group-flush my-n3">
          <div class="list-group-item bg-dark text-light rounded p-3 mb-2 lift" v-for="(q, k) in sub._" :key="k">
            <div class="row align-items-center">
              <div class="col">
                {{ q.soru_sira + ". Soru" }}
              </div>
              <div class="col-auto">
                <a 
                @click="q.soru_cozum_vimeo_id ? loadVideo(q, 'question_solution') : videoAlert(true)"
                href="javascript:;"
                class="btn btn-sm btn-success">
                  <i :class="q.soru_cozum_video == 'success' || viewed_videos[q.soru_cozum_vimeo_id] !== undefined ? 'fe fe-check-circle' : 'fe fe-x-circle'">
                  </i> Soru Çözümü
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="videoModal" data-backdrop="static" ref="videoModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ video_title }}</h5>
            <button type="button" class="close" v-on:click="playerReset()" aria-label="Kapat">
              <i class="fe fe-x-circle"></i>
            </button>
          </div>
          <div class="modal-body embed-responsive embed-responsive-16by9">
            <span v-for="subject in formatted_subject" :key="subject.soru_id">
              <div v-show="video_id === subject._[0].ders_anlatim_vimeo_id">
                <div :id="'player' + subject._[0].ders_anlatim_vimeo_id" :ref="'player' + subject._[0].ders_anlatim_vimeo_id" class="embed-responsive-item" data-plyr-provider="vimeo" :data-plyr-embed-id="subject._[0].ders_anlatim_vimeo_id"></div>
              </div>
              <div v-show="video_id === qx.soru_cozum_vimeo_id" v-for="(qx, k) in subject._" :key="k">
                <div :id="'player' + qx.soru_cozum_vimeo_id" :ref="'player' + qx.soru_cozum_vimeo_id" class="embed-responsive-item" data-plyr-provider="vimeo" :data-plyr-embed-id="qx.soru_cozum_vimeo_id"></div>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from '@/helpers/http';
import base from '@/mixins/base'

export default {
  name: 'IncompleteCompletionSubjects',
  props: ['subject', 'lesson_id'],
  data() {
    return {
      video_title: '',
      formatted_subject: '',
      video_vimeo_id: null,
      video_type: null,
      video_id: null,
      exam_id: null,
      subject_id: null,
      viewed_videos: {},
      player: {},
      ready: false,
      col_data: {}
    } 
  },
  methods: {
    playerReset() {
      if (this.player[this.video_id] !== undefined) this.player[this.video_id].pause()
      $('#videoModal').modal('hide') // eslint-disable-line

      http.post('izleme-kaydi', {
        ogrenciID: this.$store.state.auth.student_id,
        sinavID: this.$route.params.id,
        dersID: this.$route.params.sub_id,
        altkonuID: this.subject_id,
        soruID: this.col_data.soru_id,
        vimeoID: this.video_vimeo_id,
        videoTur: (this.video_title == 'Konu Anlatım Videosu' ? 0 : 1),
      }).then(response => { // eslint-disable-line  
        this.viewed_videos[this.video_vimeo_id] = true
        base.methods.incompleteCompletionData(this.$store.state.auth.student_id)
      }).catch(error => {
        throw error;
      });
    },
    test(x) {
      console.log(x)
    },
    videoAlert(question_solution = false) {
      $.confirm({ // eslint-disable-line
        title: '',
        content: (question_solution ? 'Bu soru için video bulunamadı.' : 'Bu konu için video bulunamadı.'),
        type: 'orange',
        typeAnimated: true,
        backgroundDismissAnimation: 'glow',
        buttons: {
          close: {
            text: 'Kapat',
            btnClass: 'btn-orange',
            action: function(){
            }
          }
        }
      })
    },
    loadVideo(sub, type) {
      this.col_data = sub
      this.subject_id =  sub.alt_konu_id

      this.video_vimeo_id = type == 'subject_expression' ? sub.ders_anlatim_vimeo_id : sub.soru_cozum_vimeo_id

      this.video_title = type == 'subject_expression' ? 'Konu Anlatım Videosu' : 'Soru Çözüm Videosu';
      this.video_id =  this.video_vimeo_id
      this.video_type = type;

      let id = this.video_vimeo_id

       $('#videoModal').modal('show') // eslint-disable-line

      if (this.player[id] === undefined) {

        let Plyr = this.$plyr

        this.player[id] = new Plyr(this.$refs['player'+id], {
            i18n: {
              play: 'Oynat',
              pause: 'Durdur',
              volume: 'Ses',
              mute: 'Sesi Kapat',
              unmute: 'Sesi Aç',
              enableCaptions: 'Açıklamaları etkinleştir',
              disableCaptions: 'Açıklamaları pasifleştir',
              download: 'İndir',
              enterFullscreen: 'Tam ekrana geçiş yap',
              exitFullscreen: 'Tam ekrandan çık',
              frameTitle: '{title} için oynatıcı',
              captions: 'Açıklamalar',
              settings: 'Ayarlar',
              menuBack: 'Önceki menüye dön',
              speed: 'Hız',
              normal: 'Normal',
              quality: 'Kalite',
              loop: 'Döngü',
              start: 'Oynat',
              end: 'Son',
              all: 'Tümü',
              reset: 'Sıfırla',
              disabled: 'Pasif',
              enabled: 'Aktif',
          },
          settings: []
        })
      } else {
        this.player[id].play();
      }
    },
    getQuiz(sub) {

      this.$router.push({
        name: 'IncompleteCompletionQuiz',
        params: {
          exam_id: this.$route.params.id,
          lesson_id: this.$route.params.sub_id,
          sub_id: sub.alt_konu_id,
          question_id: sub.soru_id
        }
      })

    },
  },
  created() {
    this.exam_id =  this.$route.params.id

    let found = false;
    let e = this.$store.state.exam.incomplete_completion
    let json = {}
    e.forEach(exam => {

      if ( exam.id === this.exam_id) {
        
        json = exam.json;
        Object.entries(json).forEach(lesson => {
          if ( lesson[0] === this.$route.params.sub_id ) {
            found = true
            let regeneratedData = [] // eslint-disable-line
            lesson[1][0].soru_bilgileri.forEach(q => {

              if (typeof regeneratedData[q.alt_konu_id] === 'undefined') regeneratedData[q.alt_konu_id] = {}
              if (typeof regeneratedData[q.alt_konu_id]._ === 'undefined') regeneratedData[q.alt_konu_id]._ = []

              regeneratedData[q.alt_konu_id]._.push(q)

            });

            let cleaned = {}
            let i = 0
            for (let k = 0; k < regeneratedData.length; k++) {
              const element = regeneratedData[k];
              if (element !== undefined) {
                cleaned[i] = element
                i++
              }
              
            }
            this.formatted_subject = cleaned
          }
        })

      }
    })

    if (found) {
      this.ready = true
    }

    setTimeout(() => {
      this.videos_fetched = true
    }, 100);
  }
}
</script>